import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useScheduledRequestsLdFlags = createFlagsHook<typeof import('./flags.json')>()
